module.exports = __webpack_public_path__ + "img/event.a69c6af1.svg";